import { useState, useRef, useEffect, type CSSProperties } from "react";
import { Card } from "../primitives";
import { useUpdateNode } from "../../../lib/hooks/use-kuvio";
import type { LibraryNodeDetail } from "../../../lib/types";

interface InstructionEditorProps {
  node: LibraryNodeDetail;
}

export function InstructionEditor({ node }: InstructionEditorProps) {
  const [value, setValue] = useState(node.instructions ?? "");
  const [dirty, setDirty] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const updateNode = useUpdateNode();

  useEffect(() => {
    setValue(node.instructions ?? "");
    setDirty(false);
  }, [node.id, node.instructions]);

  function handleChange(text: string) {
    setValue(text);
    setDirty(true);
  }

  function handleBlur() {
    if (!dirty) return;
    setDirty(false);
    updateNode.mutate({
      id: node.id,
      instructions: value,
    });
  }

  const label: CSSProperties = {
    fontSize: 11,
    fontWeight: 500,
    color: "var(--color-text-tertiary)",
    marginBottom: 8,
  };

  const textarea: CSSProperties = {
    width: "100%",
    minHeight: 100,
    resize: "vertical",
    fontFamily: "var(--font-sans)",
    fontSize: 13,
    lineHeight: 1.6,
    color: "var(--color-text-primary)",
    background: "transparent",
    border: "none",
    outline: "none",
    padding: 0,
  };

  return (
    <Card style={{ background: "var(--color-background-secondary)" }}>
      <div style={label}>Local instructions</div>
      <textarea
        ref={textareaRef}
        style={textarea}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        placeholder="Add instructions for this agent..."
      />
    </Card>
  );
}
